import {EventBus} from "../hermeneus.eventbus/eventbus";


window.flash = function(message, level = 'success') {
    EventBus.$emit('flash', { message, level });
};
